module.exports = __webpack_public_path__ + "static/media/const.d4ddcf36.png";


//////////////////
// WEBPACK FOOTER
// ./src/wbstdt/imgs/cat/const.png
// module id = 109
// module chunks = 0